import React from 'react'
import '../styles/style.css'
import error from '../images/error.svg'
import success from '../images/tick.svg'

class AddRemove extends React.Component {
    render() {

        return (
            <div className="modal modal-add" onClick={this.props.onClick}>
                <div className="modal-content pad-add">
                    <div className="modal-heading">                      
                        <img src={this.props.error?error:success} className="eIcon"></img>
                    </div>
                    <div className="apply-modal-header">
                        <p className="clr-add">{this.props.msg}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddRemove;